import bugsnag from "@bugsnag/js";
import { DispatchNotificationAction } from "@States/notifications";

export const errorManager = (
  dispatchNotification: DispatchNotificationAction,
  errorCode: string,
  errorMessage: string | undefined
): void => {
  if (errorMessage) {
    dispatchNotification({
      code: errorCode,
      message: errorMessage,
      type: "addNotificationByCode",
    });
  } else {
    dispatchNotification({
      code: errorCode,
      type: "addNotificationByCode",
    });
  }
  bugsnag.notify({ name: errorCode, message: errorMessage || errorCode }); // TODO: FT-174 to improve the errors management
};
